const DISMISS_KEY = "dh_dashboard_alert_dismissals";

function readDismissals() {
  try {
    return JSON.parse(localStorage.getItem(DISMISS_KEY) || "{}");
  } catch {
    return {};
  }
}

function writeDismissals(map) {
  localStorage.setItem(DISMISS_KEY, JSON.stringify(map));
}

function offsetMs(amount, unit) {
  const n = Number(amount) || 0;
  if (unit === "month") return n * 30 * 24 * 60 * 60 * 1000;
  if (unit === "day") return n * 24 * 60 * 60 * 1000;
  if (unit === "hour") return n * 60 * 60 * 1000;
  return n * 60 * 1000;
}

export function eventStart(event) {
  const date = event?.date || "";
  const time = event?.time || "09:00";
  const stamp = Date.parse(`${date}T${time}`);
  return Number.isFinite(stamp) ? stamp : null;
}

export function listDueDashboardAlerts(events = [], userId) {
  const now = Date.now();
  const dismissed = readDismissals()[userId] || {};
  const alerts = [];
  events.forEach((event) => {
    if (event.status === "cancelled") return;
    const start = eventStart(event);
    if (!start) return;
    const reminders = Array.isArray(event.reminders) && event.reminders.length
      ? event.reminders
      : [{ amount: 1, unit: "hour" }];
    reminders.forEach((reminder, index) => {
      const fireAt = start - offsetMs(reminder.amount, reminder.unit);
      if (now < fireAt || now > start + 60 * 60 * 1000) return;
      const id = `${event.id}:${index}`;
      if (dismissed[id]) return;
      alerts.push({
        id,
        eventId: event.id,
        title: event.title,
        date: event.date,
        time: event.time,
        type: event.type,
        reminder,
      });
    });
  });
  return alerts;
}

export function dismissDashboardAlert(userId, alertId) {
  const all = readDismissals();
  const mine = { ...(all[userId] || {}) };
  mine[alertId] = new Date().toISOString();
  all[userId] = mine;
  writeDismissals(all);
}
